import axios from 'axios'
import AuthApi from './../Api/AuthApi'

const LOGIN = 'LOGIN'
const LOGOUT = 'LOGOUT'

const initialState = {
  accessToken: localStorage.getItem('access_token') || '',
  userEmail: localStorage.getItem('user_email') || '',
  userLanguage: localStorage.getItem('user_language') || 'en',
  storeRefId: localStorage.getItem('store_ref_id') || '',
}

export default {
  namespaced: true,
  state: initialState,

  getters: {
    isAuthorized: state => !!state.accessToken,
    getAccessToken: state => state.accessToken,
    getUserEmail: state => state.userEmail,
    getUserLanguage: state => state.userLanguage,
    getStoreRefId: state => state.storeRefId,
    isDeveloper: state => (state.userEmail ? state.userEmail.endsWith('@everli.com') || state.userEmail.endsWith('@supermercato24.it') : false)
  },

  mutations: {
    [LOGIN] (state, { token, userEmail, userLanguage, storeRefId }) {
      state.accessToken = token
      state.userEmail = userEmail
      state.userLanguage = userLanguage
      state.storeRefId = storeRefId
    },
    [LOGOUT] (state) {
      state.userEmail = ''
      state.accessToken = ''
      state.userLanguage = ''
      state.storeRefId = ''
    }
  },

  actions: {
    /**
     * Try to authenticate user
     */
    login ({ commit }, params) {
      return AuthApi.login(params)
        .then(response => {
          const token = 'Basic ' + window.btoa(response.data.token + ':')
          const userEmail = response.data.email
          const userLanguage = response.data.language
          const storeRefId = response.data.store_ref_id

          localStorage.setItem('access_token', token)
          localStorage.setItem('user_email', userEmail)
          localStorage.setItem('user_language', userLanguage)
          localStorage.setItem('store_ref_id', storeRefId)

          // add token to every request
          axios.defaults.headers.common.Authorization = token
          
          commit(LOGIN, { token, userEmail, userLanguage, storeRefId })

          return response.data
        })
    },

    /**
     * Logout user
     */
    logout ({ commit }) {
      return AuthApi.logout()
        .finally(() => {
          localStorage.removeItem('access_token')
          localStorage.removeItem('user_name')
          localStorage.removeItem('user_language')
          localStorage.removeItem('store_ref_id')

          axios.defaults.headers.common.Authorization = ''

          commit(LOGOUT)
        })
    }
  }
}
